// 3rd party
import VueSlider from 'vue-slider-component';

import DuiBookCover from './dui-book-cover/dui-book-cover.vue';
import DuiBookSynopsis from './dui-book-synopsis/dui-book-synopsis.vue';
import DuiBookTypes from './dui-book-types/dui-book-types.vue';
import DuiCharCount from './dui-char-count/dui-char-count.vue';
import DuiCheckbox from './dui-checkbox/dui-checkbox.vue';
import DuiContextMenu from './dui-context-menu/dui-context-menu.vue';
import DuiCreditCardForm from './dui-credit-card-form/dui-credit-card-form.vue';
import DuiDateDropdowns from './dui-date-dropdowns/dui-date-dropdowns.vue';
import DuiDatepicker from './dui-datepicker/dui-datepicker.vue';
import DuiDropdown from './dui-dropdown/dui-dropdown.vue';
import DuiDropdownOption from './dui-dropdown/dui-dropdown-option.vue';
import DuiEditor from './dui-editor/dui-editor.vue';
import DuiExpandableOptions from './dui-expandable-options/dui-expandable-options.vue';
import DuiExplicitContent from './dui-explicit-content/dui-explicit-content.vue';
import DuiFileList from './dui-file-list/dui-file-list.vue';
import DuiFileUpload from './dui-file-upload/dui-file-upload.vue';
import DuiGallery from './dui-gallery/dui-gallery.vue';
import DuiHiddenField from './dui-hidden-field/dui-hidden-field.vue';
import DuiLabelGroup from './dui-label-group/dui-label-group.vue';
import DuiLoadingIndicator from './dui-loading-indicator/dui-loading-indicator.vue';
import DuiLocaleString from './dui-locale-string/dui-locale-string.vue';
import DuiOption from './dui-option/dui-option.vue';
import DuiOptionPicker from './dui-option-picker/dui-option-picker.vue';
import DuiOptionSearch from './dui-option-search/dui-option-search.vue';
import DuiPagination from './dui-pagination/dui-pagination.vue';
import DuiPopover from './dui-popover/dui-popover.vue';
import DuiProgressBar from './dui-progress-bar/dui-progress-bar.vue';
import DuiProgressSteps from './dui-progress-steps/dui-progress-steps.vue';
import DuiRadioGroup from './dui-radio-group/dui-radio-group.vue';
import DuiRating from './dui-rating/dui-rating.vue';
import DuiReviewRating from './dui-review-rating/dui-review-rating.vue';
import DuiReviewTypes from './dui-review-types/dui-review-types.vue';
import DuiScrollAvailable from './dui-scroll-available/dui-scroll-available.vue';
import DuiSearchInput from './dui-search-input/dui-search-input.vue';
import DuiSlimProgressBar from './dui-slim-progress-bar/dui-slim-progress-bar.vue';
import DuiSocialLinks from './dui-social-links/dui-social-links.vue';
import DuiStoreValue from './dui-store-value/dui-store-value.vue';
import DuiTab from './dui-tab/dui-tab.vue';
import DuiTabs from './dui-tabs/dui-tabs.vue';
import DuiToggleButton from './dui-toggle-button/dui-toggle-button.vue';
import DuiUploadTrigger from './dui-upload-trigger/dui-upload-trigger.vue';
import DuiVideoPlayer from './dui-video-player/dui-video-player.vue';
import DuiWordCount from './dui-word-count/dui-word-count.vue';
// Icons
import icons from './icons';

import './basic-components';
import 'vue-slider-component/theme/default.css';

const components = {
  DuiBookCover: DuiBookCover,
  DuiBookSynopsis: DuiBookSynopsis,
  DuiBookTypes: DuiBookTypes,
  DuiCharCount: DuiCharCount,
  DuiCheckbox: DuiCheckbox,
  DuiContextMenu: DuiContextMenu,
  DuiCreditCardForm: DuiCreditCardForm,
  DuiDateDropdowns: DuiDateDropdowns,
  DuiDatepicker: DuiDatepicker,
  DuiDropdown: DuiDropdown,
  DuiDropdownOption: DuiDropdownOption,
  DuiEditor: DuiEditor,
  DuiExpandableOptions: DuiExpandableOptions,
  DuiExplicitContent: DuiExplicitContent,
  DuiFileList: DuiFileList,
  DuiFileUpload: DuiFileUpload,
  DuiGallery: DuiGallery,
  DuiHiddenField: DuiHiddenField,
  DuiLabelGroup: DuiLabelGroup,
  DuiLoadingIndicator: DuiLoadingIndicator,
  DuiLocaleString: DuiLocaleString,
  DuiOption: DuiOption,
  DuiOptionPicker: DuiOptionPicker,
  DuiOptionSearch: DuiOptionSearch,
  DuiPagination: DuiPagination,
  DuiPopover: DuiPopover,
  DuiProgressBar: DuiProgressBar,
  DuiProgressSteps: DuiProgressSteps,
  DuiRadioGroup: DuiRadioGroup,
  DuiRating: DuiRating,
  DuiReviewRating: DuiReviewRating,
  DuiReviewTypes: DuiReviewTypes,
  DuiScrollAvailable: DuiScrollAvailable,
  DuiSearchInput: DuiSearchInput,
  DuiSlimProgressBar: DuiSlimProgressBar,
  DuiSocialLinks: DuiSocialLinks,
  DuiStoreValue: DuiStoreValue,
  DuiTab: DuiTab,
  DuiTabs: DuiTabs,
  DuiToggleButton: DuiToggleButton,
  DuiUploadTrigger: DuiUploadTrigger,
  DuiVideoPlayer: DuiVideoPlayer,
  DuiWordCount: DuiWordCount,
  'vue-slider': VueSlider,
};

Object.keys(icons).forEach((iconName) => {
  components[iconName] = icons[iconName];
});

export default components;
